import {
    Box,
    Button,
    Divider,
    Drawer,
    IconButton,
    Stack,
    Typography,
} from "@mui/material";

import EventOccurrencesViewer, {
    EventOccurrencesViewerPill,
} from "./EventOccurrencesViewer";

import Icons from "../../helpers/icons";
import { CATEGORY, resolveOwnerLabel } from "../../helpers/events";
import Colours from "../../helpers/colours";
import { formatDateRange, dayjsUTC } from "../../helpers/dates";

const dayjs = dayjsUTC;

export const EventView = ({
    event,
    extraData,
    open,
    handleClose,
    setOpenEdit,
    onEdit,
    onDelete,
}) => {
    // console.log("Event VIew", { event });

    const getUserName = (id) => {
        let user = (extraData?.Users ?? {})[id] ?? {};
        let user_name = `${user.name ?? "-"} ${user.last_name ?? "-"}`;

        return user_name;
    };

    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={handleClose}
            sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}
        >
            {/* Header Event Details */}
            <Box
                sx={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "white",
                    zIndex: (theme) => theme.zIndex.modal + 2,
                }}
            >
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{
                        p: 6,
                        pb: 2,
                        pt: 2,
                    }}
                >
                    <Typography variant="h6" fontWeight={"bold"}>
                        Event Details
                    </Typography>
                    <IconButton onClick={handleClose}>
                        <Icons.CloseNavbar />
                    </IconButton>
                </Stack>
                <Divider />
            </Box>
            {/*  Content Event Details   */}
            <Box sx={{ width: 600, p: 6, pb: 4, pt: 4 }}>
                {Object.keys(event).length > 0 ? (
                    <Stack
                        divider={
                            <Divider
                                sx={{
                                    my: 2,
                                    borderColor: Colours.midLightText,
                                }}
                            />
                        }
                    >
                        {/** Name, Category and Subcategory */}
                        <Stack>
                            <Typography variant="h5" fontWeight={"bold"}>
                                {event.Name}
                            </Typography>
                            <Stack
                                direction="row"
                                sx={{
                                    flexWrap: "wrap",
                                    alignItems: "flex-start",
                                }}
                            >
                                <Typography
                                    sx={{
                                        p: 1,
                                        paddingX: 2,
                                        m: 1,
                                        ml: 0,
                                        borderRadius: 10,
                                        width: "fit-content",
                                        border: "2px solid grey",
                                    }}
                                >
                                    {CATEGORY.hasOwnProperty(event.Category)
                                        ? CATEGORY[event.Category].label
                                        : event.Category}
                                </Typography>
                                {event.Subcategory && (
                                    <Typography
                                        sx={{
                                            p: 1,
                                            paddingX: 2,
                                            m: 1,
                                            ml: 0,
                                            borderRadius: 10,
                                            width: "fit-content",

                                            border: `2px solid ${Colours.notificationCard}`,
                                            backgroundColor:
                                                Colours.notificationCard,
                                        }}
                                    >
                                        {event.Subcategory}
                                    </Typography>
                                )}
                            </Stack>
                        </Stack>

                        {/** Period */}
                        <Stack>
                            <Typography fontWeight={"bold"}>
                                Event Period
                            </Typography>

                            <Typography>
                                {formatDateRange(
                                    event["FromDate"],
                                    event["ToDate"],
                                )}
                            </Typography>
                        </Stack>
                        {event["RepeatRule"] && (
                            <Stack>
                                <Stack
                                    direction="row"
                                    justifyContent={"space-between"}
                                >
                                    <Typography fontWeight={"bold"}>
                                        Recurrence
                                    </Typography>
                                    <EventOccurrencesViewerPill
                                        rrule={event["RepeatRule"]}
                                        start={event["FromDate"]}
                                        end={event["ToDate"]}
                                        repeatStart={event["RepeatStart"]}
                                    />
                                </Stack>
                                <EventOccurrencesViewer
                                    rrule={event["RepeatRule"]}
                                    start={event["FromDate"]}
                                    end={event["ToDate"]}
                                    repeatStart={event["RepeatStart"]}
                                    collapsible={false}
                                />
                            </Stack>
                        )}
                        <Stack>
                            <Typography fontWeight={"bold"}>
                                Description
                            </Typography>

                            <Typography>{event["Description"]}</Typography>
                        </Stack>
                        <Stack>
                            <Typography fontWeight={"bold"}>Owner</Typography>

                            <Typography>
                                {resolveOwnerLabel(
                                    event["Owner"],
                                    extraData?.Contacts ?? {},
                                )}
                            </Typography>
                            <Typography
                                variant={"caption"}
                                fontWeight={"bold"}
                                sx={{ color: Colours.graphDisabled }}
                            >
                                Event Owner
                            </Typography>
                        </Stack>
                        <Stack>
                            <Typography fontWeight={"bold"}>
                                Metadata
                            </Typography>

                            <Stack
                                direction={"row"}
                                justifyContent={"space-between"}
                            >
                                <Typography>Created by</Typography>
                                <Typography>
                                    {getUserName(event["UserID"])}
                                </Typography>
                            </Stack>
                            <Stack
                                direction={"row"}
                                justifyContent={"space-between"}
                            >
                                <Typography>Created on</Typography>
                                <Typography>
                                    {dayjs(event["CreationDate"]).format(
                                        "DD MMM YYYY",
                                    )}
                                </Typography>
                            </Stack>
                        </Stack>
                    </Stack>
                ) : (
                    <Typography
                        variant="subtitle1"
                        sx={{
                            flex: 1,
                            textAlign: "left",
                            whiteSpace: "pre-line",
                        }}
                    >
                        Something went wrong... Event has no data.
                    </Typography>
                )}
            </Box>
            {(onEdit || onDelete) && (
                <Box
                    sx={{
                        position: "sticky",
                        bottom: 0,
                        backgroundColor: "white",
                        zIndex: (theme) => theme.zIndex.modal + 2,
                    }}
                >
                    <Divider />
                    <Stack
                        direction="row"
                        spacing={1}
                        sx={{ p: 2 }}
                        justifyContent={"center"}
                    >
                        {onEdit && (
                            <Button
                                variant="outlined"
                                onClick={onEdit}
                                startIcon={<Icons.Edit />}
                            >
                                Edit
                            </Button>
                        )}
                        {onDelete && (
                            <Button
                                variant="outlined"
                                color="error"
                                onClick={() => onDelete(event)}
                                startIcon={<Icons.Delete />}
                            >
                                Delete
                            </Button>
                        )}
                    </Stack>
                </Box>
            )}{" "}
        </Drawer>
    );
};

export default EventView;
